import { Component, OnInit, Input, EventEmitter, Output, ViewChild, forwardRef } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Driver } from './../../models/driver';
import {IMyOptions} from 'mydatepicker';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalService, DriverService, CarrierService, ServerService, CommonService } from './../../services/index';
import { NotificationsService } from 'angular2-notifications';
import { Status, State, LicenceState } from './../../models/common.enum';
import { environment } from './../../../environments/environment';

var enableSignUpSubmit = function(){
  (document.getElementById("signUpSubmit") as HTMLInputElement).disabled = false;
};
window.enableSignUpSubmit = enableSignUpSubmit;

var disableSignUpSubmit = function(){
  (document.getElementById("signUpSubmit") as HTMLInputElement).disabled = true;
};
window.disableSignUpSubmit = disableSignUpSubmit;

window.recaptchaApiLoaded = function(){
  var x = document.getElementById("recaptcha_elem");
  if (x !== null && x !== undefined)
  {
    try
    {
      window.grecaptcha.render('recaptcha_elem', {
        'sitekey' : environment.recaptcha_sitekey,
        'callback' : enableSignUpSubmit,
        'expired-callback' : disableSignUpSubmit
      });
    }
    catch (error)
    {
        // can get a duplicate render under one unusual circumstance
    }
  }
};

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignUpComponent implements OnInit {
  @Input() public modalId: string;  
  @Input() public isModal: boolean;
  @Input() public role: string;
  @Output() reload: EventEmitter<any> = new EventEmitter();
  driver: Driver;
  form: FormGroup;

  submitted: boolean;
  isLoading: boolean;

  recaptcha_sitekey = environment.recaptcha_sitekey;

  today = new Date();
  dateOfBirthOptions: IMyOptions = {
        dateFormat: 'dd/mm/yyyy',
        disableSince: {year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() + 1}
  };
  licenceDateOptions: IMyOptions = {
    dateFormat: 'dd/mm/yyyy',
    disableUntil: {year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() + 1}
  };

  states: string[] = Object.keys(State).filter(k => typeof State[k as any] === 'number');
  licencestates: string[] = Object.keys(LicenceState).filter(k => typeof LicenceState[k as any] === 'number');

  constructor(
    private formBuilder: FormBuilder,
    private modalService: ModalService,
    private driverService: DriverService,
    private notificationService: NotificationsService,
    private carrierService: CarrierService,
    private serverService: ServerService,
    private router: Router,
    private spinner: NgxSpinnerService,
    ) {
      this.loadForm();
    }

    loadForm() {
      const emailRegex = /^([A-Za-z0-9_\-\.\''])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,63})$/
      this.form = this.formBuilder.group({
        id: [''],
        firstName: ['', [Validators.required]],
        lastName: ['', [Validators.required]],
        email: new FormControl('', {validators: [Validators.required, Validators.pattern(emailRegex)], updateOn: 'blur'}),
        phone: ['', [Validators.required]],
        address1: ['', [Validators.required]],
        address2: [''],
        city: ['', [Validators.required]],
        zipCode: ['', [Validators.required]],
        state: ['', [Validators.required]],
        baseState: ['', [Validators.required]],
        licenceNumber: ['', [Validators.required]],
        licenceType: ['', [Validators.required]],
        licenceExpiry: ['', [Validators.required]],
        licenceState: ['', [Validators.required]],
        dateOfBirth: ['', [Validators.required]],
        udi: ['']
      });
    }


  ngOnInit() {
    if (window.grecaptcha !== undefined)
    {
      window.grecaptcha.ready(window.recaptchaApiLoaded);
    }
  }

  OnSave(isValid: boolean) {
    this.submitted = true;
    this.isLoading = true;
    const formModel = this.form.value;
    if (!isValid) {
      // this.notificationService.error('Failure', 'Please check the fields and try again' );
      this.isLoading = false;
      return;
    }

    let reCaptchaResponse = window.grecaptcha.getResponse();

    let result;

    let driver = new Driver();
    driver.Id = 0;
    driver.FirstName = formModel.firstName,
    driver.LastName = formModel.lastName,
    driver.Email = formModel.email,
    driver.PhoneNumber = formModel.phone;
    driver.Address1 = formModel.address1,
    driver.Address2 = formModel.address2,
    driver.City = formModel.city,
    driver.ZipCode = formModel.zipCode,
    driver.State = formModel.state,
    driver.LicenceNumber = formModel.licenceNumber;
    driver.LicenceType = formModel.licenceType;
    driver.LicenceExpiry = CommonService.dateISOFormatted(CommonService.ConvertToDate(formModel.licenceExpiry, true));
    driver.LicenceState = formModel.licenceState;
    driver.BaseState = formModel.baseState;
    driver.Status = "1";
    driver.DateOfBirth = CommonService.dateISOFormatted(CommonService.ConvertToDate(formModel.dateOfBirth, true));
    result = this.driverService.signUpDriver(driver, reCaptchaResponse);

    result.subscribe(data => {
      let message: string;

      message  = 'You have successfully registered, and will receive an email';

      this.notificationService.success('Success', message);
      this.reload.emit(true);
      this.closeModal();
      this.isLoading = false;
    },
      error => {
        //this.notificationService.error('Error', error._body);
        this.isLoading = false;
        window.grecaptcha.reset();
        //this.form.controls['signUpSubmit'].enable();
        //(document.getElementById("signUpSubmit") as HTMLInputElement).disabled = false;
      });
  };

  closeModal() {
    this.submitted = false;
    this.loadForm();

    if (this.isModal) {
        this.modalService.close(this.modalId);
      } else {
        this.router.navigate(['/login']);
    }
    this.driver = null;
  }
}
